export const CheckIcon = ({
  height = 120,
  width = 120,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 120 120"
      fill="none"
    >
      <path
        d="M115 60C115 29.6243 90.3757 5 60 5C29.6243 5 5 29.6243 5 60C5 90.3757 29.6243 115 60 115C90.3757 115 115 90.3757 115 60ZM120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60Z"
        fill="#00B906"
      />
      <path
        d="M90.6299 35.8398C91.5468 34.8083 93.1282 34.7137 94.1602 35.6299C95.1917 36.5468 95.2863 38.1282 94.3701 39.1601L54.3701 84.1602C53.4532 85.1917 51.8718 85.2863 50.8398 84.3701C49.8083 83.4532 49.7137 81.8718 50.6299 80.8399L90.6299 35.8398Z"
        fill="#00B906"
      />
      <path
        d="M25.5478 60.9384C26.4103 59.8603 27.9851 59.6853 29.0632 60.5478L54.0616 80.5462C55.1397 81.4087 55.3147 82.9835 54.4522 84.0616C53.5897 85.1397 52.0149 85.3147 50.9368 84.4522L25.9384 64.4537C24.8603 63.5913 24.6853 62.0165 25.5478 60.9384Z"
        fill="#00B906"
      />
    </svg>
  );
};
